import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import "./Home.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NextEvent from "../components/NextEvent";
import EventComponent from "../components/EventComponent";
import { PaystackConsumer } from "react-paystack";
import axios from "axios";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import CarouselItem from "../components/CarouselItem";
import Loader from "react-loader-spinner";
import { readTImeEvent } from "../functions/Functions";

const programs = [
  {
    title: "Christian Mission",
    subtitle: "Missions Training",
    img: "image/activities/cmission.jpeg",
    text: "This provides opportunity for missions/evangelism minded Christians (especially those working in the academia, research institutes, Youth Corp members, postgraduate students and final year students of institutions of higher learning) in Africa and beyond. The following are the training units of this arm.",
    link: "/christianmission",
  },
  {
    title: "The Explorer",
    subtitle: "Evangelism & Discipleship",
    img: "image/activities/trips.jpg",
    text: "Evangelism and discipleship is essential to reach the unreached and establish them in Christ, including reaching out to children (using the professional missions approach – educational, medical and entrepreneurial).",
    link: "/theexplorer",
  },
  {
    title: "Mission Communication",
    subtitle: "Media & Tools",
    img: "image/activities/mc.jpeg",
    text: "Mission Communication comprises sub-teams, tools, software, resources etc. to reach more people.",
    link: "/missioncommunication",
  },
  {
    title: "The Overcomers",
    subtitle: "Intercession",
    img: "image/activities/overcomer.jpeg",
    text: "Intercession: Regularly raise awareness on the need for intercession in missions.",
    link: "/theovercomers",
  },
  {
    title: "Jehoshaphat Army",
    subtitle: "Missions through Music",
    img: "image/activities/jeo.jpeg",
    text: "Musical concerts on Christian missions in conjunction with Christian ministers in music and joint campus Christian choirs.",
    link: "/jehoshaphatarmy",
  },
  {
    title: "Blessed Generation",
    subtitle: "Professional Clinics",
    img: "image/activities/bg.jpeg",
    text: "(Educational, Entrepreneurial and Medical) – mobile professional clinics and skills acquisition/development centres.",
    link: "/blessedgeneration",
  },
  {
    title: "Good Samaritans",
    subtitle: "Support & Giving",
    img: "image/activities/support.jpg",
    text: "This provides opportunities for raising material, financial and moral support for missions.",
    link: "/goodsamaritans",
  },
];

const stats = [
  { value: "30+", label: "Years of Ministry" },
  { value: "50+", label: "Campus Chapters" },
  { value: "100+", label: "Mission Leaders Produced" },
  { value: "420+", label: "Christian Missionaries Supported" },
  { value: "5+", label: "Countries" },
];

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config_email: "",
      config_amount: 20000,
      events: [],
      blogList: [],
      loading: true,
      eventLoading: true,
    };
    this.programsRef = React.createRef();
    this.autoScrollInterval = null;
    this.ignoreNextScroll = false;
    this.resumeTimeout = null;
  }

  componentDidMount() {
    document.body.classList.add("home-page");
    axios
      .get("https://fsmission.herokuapp.com/v1/api/blog")
      .then((res) =>
        this.setState({ blogList: res.data.results, loading: false })
      );

    axios
      .get(
        "https://fsmission.herokuapp.com/v1/api/event?time=current&page_size=10000"
      )
      .then((res) =>
        this.setState({ events: res.data.results, eventLoading: false })
      );

    this.startAutoScroll();
  }

  componentWillUnmount() {
    this.stopAutoScroll();
    clearTimeout(this.resumeTimeout);
  }

  startAutoScroll = () => {
    this.stopAutoScroll();
    this.autoScrollInterval = setInterval(() => {
      const el = this.programsRef.current;
      if (!el) return;

      this.ignoreNextScroll = true;
      setTimeout(() => {
        this.ignoreNextScroll = false;
      }, 900);

      const maxScroll = el.scrollWidth - el.clientWidth;
      const currentScroll = el.scrollLeft;

      if (currentScroll >= maxScroll - 5) {
        el.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        el.scrollBy({ left: 370, behavior: "smooth" });
      }
    }, 5000);
  };

  stopAutoScroll = () => {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
  };

  handleUserInteraction = () => {
    if (this.ignoreNextScroll) return;
    this.stopAutoScroll();
    clearTimeout(this.resumeTimeout);
    this.resumeTimeout = setTimeout(() => {
      this.startAutoScroll();
    }, 8000);
  };

  handleChangeAmount(e) {
    this.setState({ config_amount: e.target.value });
  }

  handleChangeEmail(e) {
    this.setState({ config_email: e.target.value });
  }

  render() {
    const handleSuccess = (reference) => {};
    const handleClose = () => {};

    const componentProps = {
      ...{
        reference: new Date().getTime(),
        amount: this.state.config_amount * 100,
        email: this.state.config_email,
        publicKey: "pk_live_d278bdeaf49155161704db962483042078f8879e",
      },
      text: "Paystack Button Implementation",
      onSuccess: (reference) => handleSuccess(reference),
      onClose: handleClose,
    };

    return (
      <div className="App">
        <Header />

        {/* ============ HERO ============ */}
        <section
          className="fsm-hero"
          style={{
            backgroundImage:
              "url(https://fsmissionadmin.s3-us-west-2.amazonaws.com/blogs/IMG_5405.jpg)",
          }}
        >
          <div className="fsm-hero-inner container">
            <div className="fsm-hero-text">
              <span className="fsm-eyebrow">Foundation for Student Mission</span>
              <h1 className="fsm-hero-title">
                Mobilizing and Equipping <br />
                <span className="fsm-accent">Christian Students</span> for Mission
              </h1>
              <p className="fsm-hero-sub">
                It is possible for the most obscure person in a church, with a
                right heart towards God, to exercise as much power for the
                evangelization of the world as those in the most prominent
                positions.
              </p>
              <div className="fsm-hero-cta">
                <Link to="/register" className="fsm-btn fsm-btn-primary">
                  Become A Member
                </Link>
                <a href="#donationform" className="fsm-btn fsm-btn-ghost">
                  Donate Now
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ============ STATS ============ */}
        <section className="fsm-stats">
          <div className="container fsm-stats-grid">
            {stats.map((s) => (
              <div className="fsm-stat" key={s.label}>
                <div className="fsm-stat-value">{s.value}</div>
                <div className="fsm-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </section>

        <NextEvent />

        {/* ============ WHAT WE DO ============ */}
        <section className="fsm-section fsm-programs">
          <div className="container">
            <div className="fsm-section-header">
              <span className="fsm-eyebrow fsm-eyebrow-dark">Our Programs</span>
              <h2>What We Do</h2>
              <p>
                Our programs are all-encompassing, ensuring students integrate
                with every aspect of missions.
              </p>
            </div>
          </div>

          <div className="fsm-programs-scroll-wrap">
            <button
              type="button"
              className="fsm-scroll-btn fsm-scroll-btn-left"
              aria-label="Scroll left"
              onClick={() => {
                const el = document.querySelector(".fsm-programs-scroll");
                if (el) el.scrollBy({ left: -380, behavior: "smooth" });
              }}
            >
              ‹
            </button>

            <div
              className="fsm-programs-scroll"
              ref={this.programsRef}
              onMouseEnter={this.stopAutoScroll}
              onMouseLeave={this.startAutoScroll}
              onTouchStart={this.handleUserInteraction}
              onMouseDown={this.handleUserInteraction}
              onScroll={this.handleUserInteraction}
            >
              {programs.map((p) => (
                <Link to={p.link} className="fsm-program-slide" key={p.title}>
                  <div className="fsm-slide-img">
                    <img src={p.img} alt={p.title} />
                    <div className="fsm-slide-overlay"></div>
                    <span className="fsm-slide-badge">{p.subtitle}</span>
                  </div>
                  <div className="fsm-slide-body">
                    <h3>{p.title}</h3>
                    <p>{p.text}</p>
                    <span className="fsm-slide-link">
                      Learn More <span aria-hidden="true">→</span>
                    </span>
                  </div>
                </Link>
              ))}
            </div>

            <button
              type="button"
              className="fsm-scroll-btn fsm-scroll-btn-right"
              aria-label="Scroll right"
              onClick={() => {
                const el = document.querySelector(".fsm-programs-scroll");
                if (el) el.scrollBy({ left: 380, behavior: "smooth" });
              }}
            >
              ›
            </button>
          </div>
        </section>

        {/* ============ RECENT BLOG POSTS ============ */}
        <section className="fsm-section fsm-blog">
          <div className="container">
            <div className="fsm-section-header">
              <span className="fsm-eyebrow fsm-eyebrow-dark">From the Field</span>
              <h2>Recent Blog Posts</h2>
              <p>Stories, updates and reflections from our mission fields.</p>
            </div>

            {this.state.loading ? (
              <div className="fsm-loader">
                <Loader type="TailSpin" color="#E32227" height={70} width={70} />
              </div>
            ) : (
              <div className="fsm-blog-featured">
                {this.state.blogList.slice(0, 1).map((blog) => (
                  <Link
                    to={`/blog/${blog.slug}`}
                    className="fsm-featured-card"
                    key={blog.id}
                  >
                    <div className="fsm-featured-img">
                      <img src={blog.image} alt={blog.title} />
                      <span className="fsm-featured-tag">
                        {blog.category_name}
                      </span>
                    </div>
                    <div className="fsm-featured-body">
                      <h3>{blog.title}</h3>
                      <p>{blog.post_description}</p>
                      <div className="fsm-blog-meta">
                        <span>{readTImeEvent(blog.created_on, true)}</span>
                        <span>{blog.views} views</span>
                      </div>
                    </div>
                  </Link>
                ))}

                <div className="fsm-blog-side">
                  {this.state.blogList.slice(1, 3).map((blog) => (
                    <Link
                      to={`/blog/${blog.slug}`}
                      className="fsm-side-card"
                      key={blog.id}
                    >
                      <div className="fsm-side-img">
                        <img src={blog.image} alt={blog.title} />
                      </div>
                      <div className="fsm-side-body">
                        <span className="fsm-blog-cat">
                          {blog.category_name}
                        </span>
                        <h4>{blog.title}</h4>
                        <div className="fsm-blog-meta">
                          <span>{readTImeEvent(blog.created_on, true)}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>

        {/* ============ DONATE ============ */}
        <section className="fsm-donate" id="donationform">
          <div className="container fsm-donate-grid">
            <div className="fsm-donate-text">
              <span className="fsm-eyebrow">Give</span>
              <h2>
                Your donation can save <br /> many lives
              </h2>
              <p>
                The mission of God's people is not simply directed at saving
                people's souls, but it addresses and touches the injustice and
                violence around us — poverty, racism, sexism, economic
                exploitation, war, environmental destruction — where salvation,
                justice, and peace can merge.
              </p>
            </div>
            <div className="fsm-donate-card">
              <h3>How much would you like to donate (₦)?</h3>
              <div className="fsm-form-group">
                <input
                  type="text"
                  className="fsm-input"
                  placeholder="Enter Amount"
                  onChange={(e) => this.handleChangeAmount(e)}
                />
              </div>
              <div className="fsm-form-group">
                <input
                  type="email"
                  className="fsm-input"
                  placeholder="Email"
                  onChange={(e) => this.handleChangeEmail(e)}
                />
              </div>
              <PaystackConsumer {...componentProps}>
                {({ initializePayment }) => (
                  <button
                    className="fsm-btn fsm-btn-primary fsm-btn-block"
                    onClick={() =>
                      initializePayment(handleSuccess, handleClose)
                    }
                  >
                    Donate Now
                  </button>
                )}
              </PaystackConsumer>
            </div>
          </div>
        </section>

        {/* ============ UPCOMING EVENTS ============ */}
        <section className="fsm-section fsm-events">
          <div className="container">
            <div className="fsm-section-header">
              <span className="fsm-eyebrow fsm-eyebrow-dark">Calendar</span>
              <h2>Upcoming Events</h2>
              <p>Join us at our next gatherings and mission activities.</p>
            </div>

            {this.state.eventLoading ? (
              <div className="fsm-loader">
                <Loader type="TailSpin" color="#E32227" height={70} width={70} />
              </div>
            ) : (
              <div className="row">
                {this.state.events
                  .slice(Math.max(this.state.events.length - 3, 0))
                  .map((event) => (
                    <EventComponent
                      key={event.id}
                      title={event.title}
                      startDate={readTImeEvent(event.start_date, true)}
                      endDate={readTImeEvent(event.end_date, false)}
                      eventVenue={event.event_venue}
                      location={event.event_location}
                      imageLink={event.image}
                      imageThumb={event.image_thumbnail}
                      event={event}
                    />
                  ))}
              </div>
            )}
          </div>
        </section>

        {/* ============ SOCIAL STRIP ============ */}
        <section className="fsm-social">
          <div className="container fsm-social-inner">
            <h3>Connect with us</h3>
            <div className="fsm-social-icons">
              <a
                href="https://facebook.com/FSMission"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fa fa-facebook"></i>
              </a>
              <a
                href="https://twitter.com/OfficialFSM_SMC"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <i className="fa fa-twitter"></i>
              </a>
              <a
                href="https://www.instagram.com/fsmissions/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fa fa-instagram"></i>
              </a>
              <a href="#" aria-label="YouTube">
                <i className="fa fa-youtube"></i>
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default Home;